module.exports = __webpack_public_path__ + "static/assets/b5af7a55bcb8596890e91b0e9b856f3c.png";